import React, { useContext, useState } from "react";
import PropTypes from "prop-types";

import { Content, Button, Control, Field } from "rbx";

import { ModalContext } from "../ModalProvider";

const Confirmation = ({ message, onConfirm, onCancel }) => {
  const [loading, setLoading] = useState(false);
  const { setModalOpen } = useContext(ModalContext);

  const handleCancel = () => {
    setModalOpen(false, "");
    if (onCancel && typeof onCancel === "function") {
      onCancel();
    }
  };
  return (
    <div style={{ width: 400, margin: "0 auto", padding: 5 }}>
      <Content size="medium" textAlign="centered">
        <p>{message}</p>
      </Content>

      <Field align="centered" kind="group">
        <Control>
          <Button
            color="success"
            state={loading ? "loading" : ""}
            onClick={async () => {
              setLoading(true);
              await onConfirm();
              setLoading(false);
            }}
          >
            Yes
          </Button>
        </Control>
        <Control>
          <Button color="danger" disabled={loading} onClick={handleCancel}>
            No
          </Button>
        </Control>
      </Field>
    </div>
  );
};

Confirmation.propTypes = {
  message: PropTypes.string,
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func
};
export default Confirmation;
